import { render } from "./UpdateService.vue?vue&type=template&id=5938055e"
import script from "../js/update-service.js?vue&type=script&lang=js"
export * from "../js/update-service.js?vue&type=script&lang=js"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/platinumlandscapemi/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__